import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import Modal from 'react-modal';
import Papa from 'papaparse';
import axios from 'axios';
import encoding from 'encoding-japanese';
import './ModalComponent_order.css';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '50%',
    height: '50%',
  },
};

const ModalComponent_order =({ isOpen, onRequestClose ,updateTableData }) => {

  const apiUrl = process.env.NODE_ENV === 'production'
  ? process.env.REACT_APP_API_BASE_URL_PROD
  : process.env.REACT_APP_API_BASE_URL_LOCAL;

  
  const [file1Status, setFile1Status] = useState(null);
  const [file2Status, setFile2Status] = useState(null);
  const [file3Status, setFile3Status] = useState(null);

  const [file1Data, setFile1Data] = useState([]);
  const [file2Data, setFile2Data] = useState([]);
  const [file3Data, setFile3Data] = useState([]);

  const [combinedData, setCombinedData] = useState([]);

  const onDrop = useCallback((acceptedFiles) => {
    acceptedFiles.forEach((file, index) => {

      const reader = new FileReader();
      reader.onload = (e) => {
        const arrayBuffer = e.target.result;
        const uint8Array = new Uint8Array(arrayBuffer);
        const detectedEncoding = encoding.detect(uint8Array);

        const text = encoding.convert(uint8Array, {
          to: 'UNICODE',
          from:detectedEncoding,// 'SJIS',/*detectedEncoding,*/
          type: 'string'
          /*
          to: 'UTF-8',
          from: detectedEncoding,
          type: 'string'
          */

        });

        // 最初の行に改行コードが含まれている場合、それを削除する
      const cleanedText = text.replace(/^\s*\n/, '');

        Papa.parse(cleanedText, {
          complete: (result) => {
            console.log(result.data)

             // セル内の改行コードを削除
            const cleanedData = result.data.map(row => 
              row.map(cell => cell.replace(/\r?\n|\r/g, ''))
            );

            const firstCell = cleanedData[0][0];
            const firstCell2 = cleanedData[0][1];
            console.log(firstCell)
            if (firstCell === '発注品番' && firstCell2 === '商品名') {
              setFile1Status(`${file.name}：一括発注ファイル OK`);
              setFile1Data(cleanedData);
            } 

            

          },
          header: false,
        });
      };
      reader.readAsArrayBuffer(file);

    });
    
  }, [file1Data, file2Data,file3Data]);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: '.csv',
    multiple: true,
    
  });

  const handleCombineAndUpload = async () => {
    console.log(file1Data)

    // 空白行を削除する関数
  const removeEmptyRows = (data) => {
    return data.filter(row => row.some(cell => cell !== null && cell !== undefined && cell.toString().trim() !== ""));
  };

  // 空白行を削除
  const cleanedFile1Data = removeEmptyRows(file1Data);

  if (cleanedFile1Data.length > 0 ) { 
    // ファイル1の1行目（ヘッダー）を取得


    const updatedFile1 = cleanedFile1Data.slice(1); // データ部分だけを切り取る
    console.log(updatedFile1)
      try {
        const response = await axios.post(`${apiUrl}?action=processFiles_order`, { updatedFile1 });
        
        console.log("====IMPORTFILE ST====")
        console.log(response)
        
        alert("インポート成功しました。")
        
        // モーダルを閉じる
        onRequestClose();
        
      } catch (error) {
        console.error('Error processing files', error);
      }
        

    } else {
      alert('ファイルをアップロードしてください。');
    }
  };

  const handleClear = () => {
    setFile1Status(null);
    setFile2Status(null);
    setFile3Status(null);
    setFile1Data([]);
    setFile2Data([]);
    setFile3Data([]);
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={customStyles}
      contentLabel="CSV File Dropzone"
    >
      <div className="dropzone-container" {...getRootProps()}>
        <input {...getInputProps()} />
        <p>クリックまたはドロップ＆ドロップでファイルをアップロードしてください。</p>
      </div>
      <div className="status">
      <p>{file1Status}</p>
      <p>{file2Status}</p>
      <p>{file3Status}</p>
        
      </div>
      <button className="bu_update" onClick={handleCombineAndUpload}>データベースを更新</button>
      <button className="bu_clr" onClick={handleClear}>ファイルクリア</button>
      <button className="bu_close" onClick={onRequestClose}>閉じる</button>
    </Modal>
  );
};

export default ModalComponent_order;